export const lazyLoad = (target, cb) => {
  let observer = new IntersectionObserver(function (entries, observer) {
    // Detect intersection https://calendar.perfplanet.com/2017/progressive-image-loading-using-intersection-observer-and-sqip/#comment-102838
    let isIntersecting = typeof entries[0].isIntersecting === "boolean" ? entries[0].isIntersecting : entries[0].intersectionRatio > 0;
    if (isIntersecting) {
      entries.forEach(entry => {
        cb(entry.target);
      });
      observer.disconnect();
    }
  }, {
    rootMargin: "100px"
  });
  observer.observe(target);
};